const KEY = '@cloudez-app-v3/intended_location';
const FUNNEL_STEPS = ['/phone/validate', '/update/billing'];

export const saveIntendedLocation = (location): void => {
  if (!location?.pathname) return;
  if (FUNNEL_STEPS.includes(location.pathname)) return;

  try {
    sessionStorage.setItem(KEY, `${location.pathname}${location.search || ''}`);
  } catch (e) {
    // storage indisponível: o destino simplesmente não é preservado
  }
};

export const consumeIntendedLocation = (): string | null => {
  try {
    const location = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);

    return location || null;
  } catch (e) {
    return null;
  }
};

export const clearIntendedLocation = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // nada a fazer
  }
};
